// material-ui
import {
  Box,
  Typography
} from '@mui/material';
import { Key } from 'react';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
      <Box sx={{ p: 3, minHeight:400, background: '#F1FAF0', borderRadius: '20px', margin: '15px', paddingLeft: '40px' }} >
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

interface TabContentProps {
  featuresObject: any;
}

export const TabContent = (props: TabContentProps) => {
  const { featuresObject } = props;

  const renderItems = () => {
    return featuresObject.map((card: any, index: Key) => {
      return <li key={index}>{card}</li>;
    });
  };

  return (
    <ul>
      {renderItems()}
    </ul>
  );
}
